module.exports = __webpack_public_path__ + "images/category_lp/common/icon-company-2@2x_e0d4fee5a74cef297108b899cf9d80ff.png";